export const GET_COUNTRY_LIST = 'COUNTRY_LIST';
export const GET_ANNOUNCEMENT = 'ANNOUNCEMENT';
export const HIDE_ANNOUNCEMENT = 'HIDE_ANNOUNCEMENT';
export const BOOKING_REQUEST = 'BOOKING_REQUEST';
export const PAGE_CONTENT_REQUEST = 'PAGE_CONTENT_REQUEST';
export const SET_LEFT_MENU_DISPLAY = 'SET_LEFT_MENU_DISPLAY';
export const SEND_DMCA_REQUEST = 'SEND_DMCA_REQUEST';
export const YOUTUBE_PODCAST = 'YOUTUBE_PODCAST';
export const SPOTIFY_PLAYLISTS = 'SPOTIFY_PLAYLISTS';
